<template>
  <v-container fluid>
    <v-form>
      <v-card>
        <v-card-text>
          <h4 class="primary--text">
            {{ $route.params.notificationId ? "Edit" : "Create" }} Notification
            Template
          </h4>
        </v-card-text>
        <gru-form-base
          layout="column"
          :value="notificationProfile"
          :schema="mySchema"
          :doSubmit="doSubmit"
          :doBack="doBack"
        />
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { router } from "../../router";
import { mapState, mapGetters } from "vuex";
import { CrudService } from "@/services";
import { message } from "@/shared/message";

export default {
  name: "NotificationProfileEdit",
  data() {
    return {
      types: "",
      resource: "notification",
      notificationProfile: {
        id: 0,
        title: "",
        description: "",
        type: "",
        newType: '',
        sender: this.$store.state.auth.user.username,
        receiver_arr: [],
        receiver: "",
        variable: "",
        template: "",
        send_at: "",
        read_at: "",
        note: false,
        status: true
      },
      itemCount: 0,
      templateFieldCount: 0,
      addType: false,
    };
  },
  methods: {
    doSubmit() {
      this.notificationProfile.receiver = JSON.stringify(
        this.notificationProfile.receiver_arr.map(a => a.text)
      );
      if (this.$route.params.notificationId) {
        CrudService.of(this.resource)
          .updateItem(this.notificationProfile)
          .then(new_item => {
            message.success(
              this.$t("lang.common.update_success"),
              `/${this.resource}/edit/` + new_item.notificationId
            );
            router.push(
              `/${this.resource}/`
            );
          });
      } else {
        CrudService.of(this.resource)
          .createItem(this.notificationProfile)
          .then(new_item => {
            message.success(
              this.$t("lang.common.add_success"),
              `/${this.resource}/edit/` + new_item.notificationId
            );
            router.push(
              `/${this.resource}/`
            );
          });
      }
    },
    doBack() {
      router.push(
        `/${this.resource}/`
      );
    },
    reloadNotificationItem(id) {
      if (id) {
        let vm = this;
        CrudService.of(this.resource)
          .getItem(id)
          .then(item => {
            vm.notificationProfile = item;
            vm.notificationProfile.receiver_arr = [];
            let temp = JSON.parse(vm.notificationProfile.receiver);
            for (let i = 0; i < temp.length; i++) {
              vm.notificationProfile.receiver_arr.push({
                text: temp[i],
                value: vm.candidate.filter(function(a) {
                  return a.text === temp[i];
                })[0].value
              });
            }
          });
      }
    }
  },
  computed: {
    candidate() {
      return this.$store.getters.userList;
    },
    ...mapState({
      mySchema() {
        return {
          id: { type: "text", hidden: true },
          title: {
            type: "text",
            label: "lang.notification.title",
            validate: "required|max:50",
            focus: true
          },
          description: {
            type: "text",
            label: "lang.notification.description",
            validate: "required|max:255",
          },
          type: {
            type: "radio",
            label: "lang.notification.type",
            validate: "required",
            options: this.$store.getters.notificationTypes,
          },
          receiver_arr: {
            type: "chipsInline",
            label: "lang.notification.receiver",
            items: this.candidate,
            values: this.notificationProfile.receiver_arr
          },
          template: {
            type: "textarea",
            label: "lang.notification.template",
            validate: "required|max:10000"
          },
          note: {
            type: "checkbox",
            label: "lang.notification.sendToUsername"
          },
          status: {
            type: "checkbox",
            label: "lang.notification.active"
          }
        };
      },
      currentLang() {
        return this.$store.getters.selectedLocale.locale;
      },
      loading() {
        return this.$store.state.common.loading;
      },
      isEdited() {
        return (
          this.$route.params.templateId !== null &&
          this.$route.params.templateId !== undefined
        );
      },
      itemFields() {
        return [
          {
            value: "title" + this.selectedLocaleIndex,
            text: "lang.dashboard.title",
            columnType: "STRING",
            editable: true
          },
          {
            value: "contentTemplate",
            text: "lang.dashboard.contentTemplate",
            columnType: "STRING"
          },
          {
            value: "active",
            text: "lang.common.status",
            optionValues: this.allStateTypes,
            columnType: "BOOLEAN"
          }
        ];
      },
      templateFieldFields() {
        return [
          {
            value: "columnName",
            text: "lang.dashboard.fieldName",
            columnType: "STRING",
            editable: true
          },
          {
            value: "title" + this.selectedLocaleIndex,
            text: "lang.dashboard.title",
            columnType: "STRING"
          },
          {
            value: "columnType",
            text: "lang.dashboard.fieldType",
            columnType: "STRING"
          },
          {
            value: "controlType",
            text: "lang.dashboard.controlType",
            optionValues: this.allControlTypes,
            columnType: "STRING"
          },
          {
            value: "active",
            text: "lang.common.status",
            optionValues: this.allStateTypes,
            columnType: "BOOLEAN"
          }
        ];
      }
    }),
    ...mapGetters(["selectedLocaleIndex"])
  },
  mounted() {
    this.active_tab = parseInt(this.$route.params.tabId) || 0;
  },
  created() {
    this.$store.dispatch("getUserList");
    this.$store.dispatch("getNotificationTypeList");
    if (this.$route.params.notificationId) {
      this.reloadNotificationItem(this.$route.params.notificationId);
    } else {
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
  }
};
</script>
